
import React, { useState, useEffect, useContext } from "react";
import Footer from "../components/dashboard/footer";
import Header from "../components/dashboard/header";
// import Sidebar from "../components/dashboard/clinicianSidebar";
import { useNavigate, Link } from "react-router-dom";
import { useParams } from 'react-router-dom';
import tmdbApi from "../api/tmdbApi";
import axios from 'axios';
import moment from "moment";

import Select from 'react-select';
import Loader from "../components/loader";

import SweetAlert from 'react-bootstrap-sweetalert';
import { contentContext } from "../context/contentContext";
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import SideMenu from "./student/SideMenu";
import Sidebar from "../components/dashboard/sidebar";
import SessionPopup from "./SessionPopup";
let { lambda, country, appname } = window.app;

const EditTest = () => {
    let { id } = useParams();
    const navigate = useNavigate();
    const [msg, setMsg] = useState("");
    const [activeTab, setActiveTab] = useState("caseinfo");

    const [isLoading, setIsLoading] = useState(false);
    const [isUserAdd, setIsUserAdd] = useState(false);
    const [feeError, setEmailError] = useState('');

    const [pathrefnoError, setpathrefnoError] = useState('');
    const [pathrefdateError, setpathrefdateError] = useState('');
    const [biopsydateError, setbiopsydateError] = useState('');
    const [patientnameError, setpatientnameError] = useState('');
    const [ageError, setageError] = useState('');
    const [sexError, setsexError] = useState('');
    const [emailError, setemailError] = useState('');
    const [clinicianError, setclinicianError] = useState('');
    const [clinicregistrationnumberError, setclinicregistrationnumberError] = useState('');
    const [specimentypeError, setspecimentypeError] = useState('');
    const [siteofbiopsyError, setsiteofbiopsyError] = useState('');
    const [clinicalhistoryError, setclinicalhistoryError] = useState('');

    const [testList, setTestList] = useState([])
    const [biopsyList, setBiopsyList] = useState([])
    const [selectedTests, setSelectedTests] = useState([]);
    const [selectedBiopsy, setSelectedBiopsy] = useState([]);
    const [showAdditional, setAdditionalTest] = useState(false);

    const [biopsyAPI, setbiopsyAPI] = useState(true);

    const [resourceBucket, setResourceImg] = useState(false);
    const [imageCloudfront, setimageCloudfront] = useState('');
    const [pdfFiles, setPdfFiles] = useState([])
    const [pdfUrls, setPdfUrls] = useState(null);
    const [pdfIndex, setPdfIndex] = useState(0)

    const [clinicalimageFiles, setclinicalImageFiles] = useState([])
    const [clinicalimagesUrls, setClinicalImageUrls] = useState(null);
    const [clinicalimageIndex, setClinicalImageIndex] = useState(0)
    const [fileSizeError, setFileSizeError] = useState(false);
    const [fileSizeErrorMsg, setFileSizeErrorMsg] = useState("");
    const [showImagePopup, setShowImagePopup] = useState(false);
    const [popupImage, setPopupImage] = useState(null);
    const [deleteImage, setdeleteImage] = useState(false);
    const [deleteImageId, setDeleteImageId] = useState(null);
    const [deleteImageSuccess, setDeleteImageSuccess] = useState(false);
    const [deleteimageType, setImageType] = useState(null);

    const [nameError, setNameError] = useState('');
    const [phoneError, setPhoneError] = useState('');
    const [IdcError, setIdcError] = useState('');
    const [typeError, setTypeError] = useState('');
    const [toastMessage, setToastMessage] = useState(""); // State for dynamic message
    const [managertypeError, setManagerTypeError] = useState('');
    const [editUser, setEditUser] = useState({
        "pathrefno": "",
        "pathrefdate": "",
        "patientname": "",
        "age": "",
        "sex": "",
        "phone": "",
        "email": "",
        "clinician": "",
        "clinicregistrationnumber": "",
        "siteofbiopsy": "",
        "clinicalhistory": "",
        "specimentype": "",
    });
    const [permission, setPermission] = useState({});
    const [success, setSuccess] = useState(false);
    const [UpdateSuccess, setUpdateSuccess] = useState(false);
    const [image, setImg] = useState('');
    const [manager, setManagers] = useState({});
    const [selectAll, setSelectAll] = useState(false);
    const [showSessionPopupup, setShowSessionPopupup] = useState(false);
    const [existmsg, setExistMsg] = useState(false);
    const [Ismsg, setIsMsg] = useState(false);
    const [checkStatus, setCheckStatus] = useState(false);
    const [invalidContent, setInvalidContent] = useState(false);
    const userType = (localStorage.getItem("userType") || "").toLowerCase().trim();
    const userId = localStorage.getItem("userId");

    // ── Lab Incharge state ──────────────────────────────────────────────────
    const [pathologistList, setPathologistList] = useState([]);
    const [selectedPathologistId, setSelectedPathologistId] = useState("");
    const [histologyFiles, setHistologyFiles] = useState([]);
    const [histologyUrls, setHistologyUrls] = useState(null);
    const [histologyIndex, setHistologyIndex] = useState(0);
    const [isActionLoading, setIsActionLoading] = useState(false);
    const [additionalTestPaymentDone, setAdditionalTestPaymentDone] = useState(false);
    // ───────────────────────────────────────────────────────────────────────

    // ── Pathologist state ───────────────────────────────────────────────────
    const [diagnosis, setDiagnosis] = useState("");
    const [histopathFindings, setHistopathFindings] = useState("");
    const [pathRemarks, setPathRemarks] = useState("");
    const [additionalTestDetails, setAdditionalTestDetails] = useState("");
    const [additionalTestCost, setAdditionalTestCost] = useState("");
    const [pathAdditionalTests, setPathAdditionalTests] = useState([]);
    // ───────────────────────────────────────────────────────────────────────

    const { route, setRoute, setCurrentPage, setRowsPerPage, setActiveMenuObj, usePrevious, userData, setActiveMenuId, GetTimeActivity } = useContext(contentContext);

    const prevRoute = usePrevious(route)
    useEffect(() => {
        if (prevRoute !== undefined && prevRoute !== route) {
            setCurrentPage(1)
            setRowsPerPage(15)
        }
    }, [prevRoute]);
    useEffect(() => {

        if (window.site === undefined) {
            setTimeout(() => {
                if (window.site && window.site.common && window.site.common.imageCloudfront) {
                    setImg(window.site.common.imageCloudfront)
                    setimageCloudfront(window.site.common.imageCloudfront)
                    setResourceImg(window.site.common.resourceBucket)
                }
            }, 1000);
        }
        if (window.site && window.site.common && window.site.common.imageCloudfront) {
            setImg(window.site.common.imageCloudfront)
            setimageCloudfront(window.site.common.imageCloudfront)
            setResourceImg(window.site.common.resourceBucket)
        }


    }, [window.site]);



    useEffect(() => {
        if (!localStorage.getItem("token")) {
            navigate("/");
        }
        setActiveMenuId(200005)
        setActiveMenuObj({
            "Client Management": false,
            "Contact Management": false,
            "Reports": false
        })
        setRoute("user")
        if (id) {
            getuser();


        }
        getLookupInfo("Tests")
        if (userType === "lab technician") {
            fetchPathologists();
        }
    }, []);

    const userActivity = () => {
        let path = window.location.pathname.split("/");
        const pageName = id !== undefined ? path[path.length - 2] : path[path.length - 1];;
        var presentTime = moment();
        let payload;

        payload = {
            "userid": localStorage.getItem("userId"),
            "pagename": pageName,
            "pageurl": window.location.href,
            "starttime": presentTime,
            "useragent": JSON.parse(localStorage.getItem("loc"))

        };


        const previousId = localStorage.getItem("previousid");
        const urlLink = lambda + '/useractivity?appname=' + appname + (previousId ? "&previousid=" + previousId : "");


        axios({
            method: 'POST',
            url: urlLink,
            data: payload
        })
            .then(function (response) {
                if (response?.data?.statusCode === 200) {
                    localStorage.setItem("previousid", response?.data?.result)
                }
            });
    }

    const getLookupInfo = async (type) => {
        const response = await tmdbApi.lookupInfo(type);


        if (response?.result?.length > 0) {
            if (type == "Tests") {
                setTestList(response?.result)
            } else if (type == "Biopsy") {
                setBiopsyList(response?.result)
            }

        }
    }

    const getuser = (e) => {
        GetTimeActivity()
        const token = localStorage.getItem("token")
        axios({
            method: 'GET',
            url: lambda + '/biopsyCaseInfo?appname=' + appname + '&patientid=' + id,
        })
            .then(function (response) {
                //  console.log("response", response?.data?.result?.[0]);
                if (response?.data?.result === "Invalid token or Expired") {
                 setShowSessionPopupup(true)
    //             localStorage.clear();
    //    navigate("/")
                }
                // else {
                if (response?.data?.result.length > 0) {
                    setEditUser(response?.data?.result?.[0]);
  
                     setSelectedTests(response?.data?.result?.[0]?.tests)
                        setSelectedBiopsy(response?.data?.result?.[0]?.biopsyType)
                    if (response?.data?.result?.[0] && response?.data?.result?.[0]?.permissions) {
                        setPermission(response?.data?.result?.[0]?.permissions)
                    }
                } else {
                    setInvalidContent(true)
                }
                //  }
                // getPermissions(response?.data && response?.data?.result && response?.data?.result?.[0] && response?.data?.result?.[0]?.type)
            });
    }

    const onclickInvalid = () => {
        GetTimeActivity()
        setInvalidContent(false)
        navigate('/biopsy/cases')
    }

    // const getManagers = (e) => {
    //     GetTimeActivity()
    //     const token = localStorage.getItem("token")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/users?appname=' + appname + "&token=" + token + "&type=MANAGER",
    //     })
    //         .then(function (response) {
    //             console.log(response);
    //             setManagers(response?.data?.result)
    //         });
    // }



    // const getPermissions = (userType) => {
    //     GetTimeActivity()
    //     const token = localStorage.getItem("token")
    //     axios({
    //         method: 'GET',
    //         url: lambda + '/userPermissions?appname=' + appname + '&type=' + userType + "&token=" + token,
    //     })
    //         .then(function (response) {
    //             console.log("response?.data?.result?.data[0]", response?.data?.result?.data[0])
    //             if (response?.data?.result === "Invalid token or Expired") {
    //                  setShowSessionPopupup(true)
    //                 localStorage.clear();
    //    navigate("/")
    //             } else {
    //                 setPermission(response?.data?.result?.data[0].permissions)
    //             }
    //         });
    // }

    // const handleCountryChange = (e) => {
    //     const newCountry = e.target.value;
    //     // setIdc(newCountry); // Update state

    //     setEditUser((prev) => ({
    //         ...prev,
    //         idc: newCountry,
    //         phone: "", // Reset phone number when country changes
    //     }));

    // };


    // const handleChange = (e) => {
    //     console.log('typeeeeeeeeee', e.target.value)
    //     console.log('nameeeee', e.target.name)
    //     if (e.target.name === "userType") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         // getPermissions(e.target.value);
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });

    //     } else if (e.target.name === "manager") {
    //         for (let key in manager) {
    //             if (manager.hasOwnProperty(key) && manager[key].userid === e.target.value) {
    //                 setEditUser({ ...editUser, [e.target.name]: e.target.value })
    //             }

    //         }

    //     } else if (e.target.name === "status") {
    //         if (id) {
    //             setCheckStatus(true);
    //         }
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     } else {
    //         setEditUser({ ...editUser, [e.target.name]: e.target.value });
    //     }



    // }

    const toggleAdditional = (e) => {
        setAdditionalTest(!showAdditional);
        setbiopsyAPI(false)
        if (biopsyAPI) {
            getLookupInfo("Biopsy")
        }

    }

    const handleSelectChange = (selected) => {
        setSelectedTests(selected);
    }

    const handleBiopsyChange = (selected) => {
        setSelectedBiopsy(selected);
    }

    const handleChange = (e) => {
        const { name, value } = e.target;


        if (name === "usertype") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        if (name === "phone") {
            let formattedValue = value;
            let numericValue = value.replace(/\D/g, ""); // Remove non-numeric characters
            const currentIdc = editUser?.idc?.trim(); // Remove unnecessary spaces

            if (currentIdc === "USA") {
                console.log("Using USA Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 6) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3, 6)}-${numericValue.slice(6)}`;
                } else if (numericValue.length > 3) {
                    formattedValue = `(${numericValue.slice(0, 3)}) ${numericValue.slice(3)}`;
                } else {
                    formattedValue = numericValue;
                }
            } else if (currentIdc === "IND") {
                console.log("Using India Format");
                if (numericValue.length > 10) numericValue = numericValue.slice(0, 10);
                if (numericValue.length > 5) {
                    formattedValue = `${numericValue.slice(0, 5)}-${numericValue.slice(5)}`;
                } else {
                    formattedValue = numericValue;
                }
            }

            // Update the phone number only
            setEditUser(prev => ({ ...prev, phone: formattedValue }));
            return; // Stop further execution for "phone" field
        }

        else if (name === "manager") {
            for (let key in manager) {
                if (manager.hasOwnProperty(key) && manager[key].userid === value) {
                    setEditUser(prev => ({ ...prev, [name]: value }));
                    break; // No need to continue looping after finding the match
                }
            }
        }

        else if (name === "status") {
            if (id) {
                setCheckStatus(true);
            }
            setEditUser(prev => ({ ...prev, [name]: value }));
        }

        else {
            setEditUser(prev => ({ ...prev, [name]: value }));
        }
    };
    const handleChangeMultiSelect = (selected, key) => {
        setEditUser({ ...editUser, [key]: selected });

    }
    function onConfirm() {
        GetTimeActivity()
        setSuccess(false);
        navigate("/users")
    };

    console.log('edituser',editUser)

    const handleAddUser = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            createuser();
        }
    }

    function formvalidation() {
        GetTimeActivity()
        let formIsValid = true;
        // if (editUser?.emailid === undefined || editUser?.emailid?.trim() === "") {
        //     setEmailError("Please enter Email");
        //     setTimeout(function () { setEmailError("") }, 3000);
        //     formIsValid = false;
        // }
        // const regEx = /[a-zA-Z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,8}(.[a-z{2,8}])?/g;
        // if (regEx.test(editUser?.emailid)) {
        //     setEmailError("");
        //     setTimeout(function () { setEmailError("") }, 3000)
        // } else if (!regEx.test(editUser?.emailid) && editUser?.emailid !== "") {
        //     setEmailError("Please Enter Fee");
        //     setTimeout(function () { setEmailError("") }, 3000)
        //     formIsValid = false;
        // }

        if (editUser?.pathrefno === undefined || editUser?.pathrefno?.trim() === "") {
            setpathrefnoError("Please Enter Path Ref No");
            setTimeout(function () { setpathrefnoError("") }, 3000);
            formIsValid = false;
        }
        if (editUser?.pathrefdate === undefined || editUser?.pathrefdate?.trim() === "") {
            setpathrefdateError("Please Enter Path Ref Date");
            setTimeout(function () { setpathrefdateError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.biopsydate === undefined || editUser?.biopsydate?.trim() === "") {
            setbiopsydateError("Please Enter Biopsy Date");
            setTimeout(function () { setbiopsydateError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.patientname === undefined || editUser?.patientname?.trim() === "") {
            setpatientnameError("Please Enter Patient Name");
            setTimeout(function () { setpatientnameError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.email === undefined || editUser?.email?.trim() === "") {
            setemailError("Please Enter Email");
            setTimeout(function () { setemailError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.clinicregistrationnumber === undefined || editUser?.clinicregistrationnumber?.trim() === "") {
            setclinicregistrationnumberError("Please Enter Clinic Registration Number");
            setTimeout(function () { setclinicregistrationnumberError("") }, 3000);
            formIsValid = false;
        }

        //      if (editUser?.clinician === undefined || editUser?.clinician?.trim() === "") {
        // setclinicianError("Please Enter Clinician Name");
        //         setTimeout(function () { setclinicianError("") }, 3000);
        //         formIsValid = false;
        //     }

        if (editUser?.specimentype === undefined || editUser?.specimentype?.trim() === "") {
            setspecimentypeError("Please Enter Specimen Type");
            setTimeout(function () { setspecimentypeError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.siteofbiopsy === undefined || editUser?.siteofbiopsy?.trim() === "") {
            setsiteofbiopsyError("Please Enter Site of Biopsy");
            setTimeout(function () { setsiteofbiopsyError("") }, 3000);
            formIsValid = false;
        }

        if (editUser?.clinicalhistory === undefined || editUser?.clinicalhistory?.trim() === "") {
            setclinicalhistoryError("Please Enter Clinical History");
            setTimeout(function () { setclinicalhistoryError("") }, 3000);
            formIsValid = false;
        }



        // if (editUser?.fee === undefined || editUser?.fee?.trim() === "") {
        //     setEmailError("Please enter fee");
        //     setTimeout(function () { setEmailError("") }, 3000);
        //     formIsValid = false;
        // }

        // if (!editUser?.phoneNumber?.trim()) {
        //     setPhoneError("Enter phone number");
        //     setTimeout(() => setPhoneError(""), 3000);
        //     formIsValid = false;
        // }

        // if (editUser?.userType === "") {
        //     setTypeError("Please select Type");
        //     setTimeout(function () { setTypeError("") }, 3000);
        //     formIsValid = false;
        // }



        // if (editUser?.type === "ACCOUNTMANAGER" || editUser?.type === "CONTENTMANAGER" || editUser?.type === "MANAGER") {
        //     if (editUser?.manager === "" || editUser?.manager === undefined) {
        //         setManagerTypeError("Please select Manager");
        //         setTimeout(function () { setManagerTypeError("") }, 3000);
        //         formIsValid = false;
        //     }
        // }

        return formIsValid;
    }


    const handleSubmit = () => {
        GetTimeActivity()
        setIsLoading(true)

        const token = localStorage.getItem("token")
        let payload = {}
        payload = {

            // "userType": editUser?.userType,
            "pathrefno": editUser?.pathrefno,
            "pathrefdate": editUser?.pathrefdate,
            "biopsydate": editUser?.biopsydate,
            "patientname": editUser?.patientname,
            "age": editUser?.age,
            "sex": editUser?.sex,
            "phone": editUser?.phone,
            "email": editUser?.email,
            "clinician": editUser?.clinician,
            "clinicregistrationnumber": editUser?.clinicregistrationnumber,
            "siteofbiopsy": editUser?.siteofbiopsy,
            "clinicalhistory": editUser?.clinicalhistory,
            "specimentype": editUser?.specimentype,

        }

        if (selectedTests && selectedTests?.length > 0) {
            payload["tests"] = selectedTests
        }

        if (selectedBiopsy && selectedBiopsy?.length > 0) {
            payload["biopsy"] = selectedBiopsy
        }

        axios({
            method: 'POST',
            url: lambda + '/updateBiopsyCase?appname=' + appname + '&patientid=' + id,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    if (response?.result === "Invalid token or Expired") {
                         setShowSessionPopupup(true)
                        localStorage.clear();
       navigate("/")
                    } else if (response?.data?.result === "This ACM assaigned to companies") {
                        setIsMsg(true);
                        setIsLoading(false);
                    } else {
                        setIsLoading(false);
                        setUpdateSuccess(true)
                        setToastMessage("Updated Successfully")
                    }
                }

            });
    }


    const handleUpdate = (e) => {
        GetTimeActivity()
        const isValid = formvalidation();
        if (isValid) {
            handleSubmit();
        }
    }
    const createuser = async () => {
        setIsLoading(true)

        // GetTimeActivity()   
        let payload = {}
        payload = {
            "pathrefno": editUser?.pathrefno,
            "pathrefdate": editUser?.pathrefdate,
            "biopsydate": editUser?.biopsydate,
            "patientname": editUser?.patientname,
            "age": editUser?.age,
            "gender": editUser?.gender,
            "phone": editUser?.phone,
            "email": editUser?.email,
            "referringDoctor": editUser?.referringDoctor,
            "clinicregistrationnumber": editUser?.clinicregistrationnumber,
            "siteofbiopsy": editUser?.siteofbiopsy,
            "clinicalhistory": editUser?.clinicalhistory,
            "specimentype": editUser?.specimentype
        }
        if (selectedTests && selectedTests?.length > 0) {
            payload["tests"] = selectedTests
        }

        if (selectedBiopsy && selectedBiopsy?.length > 0) {
            payload["biopsy"] = selectedBiopsy
        }

        const token = localStorage.getItem("token")
        const userId = localStorage.getItem("userId")
        axios({
            method: 'POST',
            url: lambda + "/addBiopsyCase?appname=" + appname + "&userid=" + userId,
            data: payload,
        })
            .then(function (response) {
                if (response) {
                    console.log("response?.result", response)
                    if (response?.data?.result === "User already exists") {
                        setIsLoading(false)
                        setExistMsg(true)

                    }
                    else if (response?.result === "Invalid token or Expired") {
                        setIsLoading(false)
                        setShowSessionPopupup(true)
                    }
                    else {
                        setIsLoading(false)
                        setSuccess(true);
                        setToastMessage("Details Created Successfully")
                        setTimeout(() => {
                            navigate("/biopsy/cases"); // Trigger API call AFTER toast is displayed
                        }, 2000);
                    }
                }

            });

    };

    const handleBack = (e) => {
        GetTimeActivity()
        if (id) {
            navigate({
                pathname: "/biopsy/cases",
                state: { search: true }
            });
        } else {
            navigate("/biopsy/cases")
        }
    }

    const CancelClick = () => {
        GetTimeActivity()
        setIsMsg(false);
        navigate("/biopsy/cases")
    }



    const handlePdfChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);

        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            // let fileSize = 1048612 * 20 // 20MB

            if (pdfIndex > 0) {
                index = index + pdfIndex
            }
            let urlobj = URL.createObjectURL(file)

            setPdfFiles((prevData) => ([
                ...prevData, // Keep the other fields intact
                file
            ]));

            setPdfUrls((prevData) => ({
                ...prevData, // Keep the other fields intact
                ["blob" + index]: {
                    url: urlobj,
                    name: file?.name
                }, // Update the changed field
            }));
            setPdfIndex(index + 1)


        })

    };

    const handlePdfDelete = (e, key) => {
        let imgUrls = { ...pdfUrls }
        let imgIndex = pdfIndex

        setPdfFiles(pdfFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setPdfUrls(imgUrls)
        setPdfIndex(imgIndex - 1)

    }

    const handlePopupImage = (imageUrl) => {
        setShowImagePopup(true)
        setPopupImage(imageUrl)
    }

    const handleClinicalImageDelete = (e, key) => {
        let imgUrls = { ...clinicalimagesUrls }
        let imgIndex = clinicalimageIndex

        setclinicalImageFiles(clinicalimageFiles.filter(item => item.name !== imgUrls[key]?.name));
        if (imgUrls[key]) {
            delete imgUrls[key]
        }
        setClinicalImageUrls(imgUrls)
        setClinicalImageIndex(imgIndex - 1)

    }

    const handleimageFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        // console.log('ques', questionData?.files.length, imageFiles?.length, selectedFiles?.length)



        Array.from(selectedFiles).map(async (file, index) => {
            // File size enable
            let fileSize = 1048612 * 20 // 20MB
            if (file?.size < fileSize) {
                if (clinicalimageIndex > 0) {
                    index = index + clinicalimageIndex
                }
                console.log("index", index)
                let urlobj = URL.createObjectURL(file)
                let img = new Image();
                img.onload = function () {
                    setclinicalImageFiles((prevData) => ([
                        ...prevData, // Keep the other fields intact
                        file
                    ]));

                    setClinicalImageUrls((prevData) => ({
                        ...prevData, // Keep the other fields intact
                        ["blob" + index]: {
                            url: urlobj,
                            name: file?.name
                        }, // Update the changed field
                    }));
                    setClinicalImageIndex(index + 1)
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true)
                setFileSizeErrorMsg("File size greater than 20MB")
            }


        })

    };

    const handleImageFileDelete = async (e, item, key, type) => {
        // console.log("item ", item)
        setdeleteImage(true)
        let obj = item
        obj["index"] = key
        setDeleteImageId(item)
        setImageType(type)
    }


    const imageFileDelete = async (e) => {
        setdeleteImage(false)
        try {
            let params = {
                "source_bucket": resourceBucket,
                "sourcepath": deleteImageId?.sourcepath,
                "fileid": deleteImageId?.fileid
            }

            if (deleteimageType == "file") {
                await tmdbApi.deleteHistoricFiles(id, params);
            } else {
                await tmdbApi.deleteOmeFiles(id, params);
            }


            setDeleteImageSuccess(true)
        } catch {
            console.log("error");
        }
    }

    const onDelImageCancel = (e) => {
        setdeleteImage(false)
        setDeleteImageId(null)

    }

    const ondeleteImageConfirm = (e) => {
        setDeleteImageSuccess(false)
        let deleteImageIndex = deleteImageId["index"]
        if (deleteImageIndex > -1) { // only splice array when item is found
            editUser["historyfiles"].splice(deleteImageIndex, 1); // 2nd parameter means remove one item only
        }
        setDeleteImageId(null)
        let imgIndex = clinicalimageIndex
        setClinicalImageIndex(imgIndex - 1)
    }


    const handleFileUpload = async (files, biopsyid) => {
        // setUploadImg(true);

        if (files && files.length > 0) {
            let filesArray = [];

            // Convert all file uploads into an array of promises
            const uploadPromises = Array.from(files).map(async (file) => {
                const timestamp = Date.now();
                const fileExtension = file?.name?.split('.').pop();
                const ObjectID = require("bson-objectid");
                const uniqueId = new ObjectID().toString();

                let uploadFilePath;
                let bucket;

                if (file.type.startsWith('image/')) {
                    let filenameReplace = file.name.replace(/ /g, "_");
                    //uploadFilePath = `${appname}/${caseid}/${filenameReplace.split('.')[0]}_image_${timestamp}.${fileExtension}`;
                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const fileNameUnique = `${uniqueId}_image_${timestamp}.${fileExtension}`;
                    const uploadFilePath = `${appname}/${biopsyid}/${uniqueId}/${fileNameUnique}`;


                    bucket = window.site && window.site.common && window.site.common.resourceBucket;

                    const data = {
                        source_bucket: bucket,
                        sourcepath: uploadFilePath
                    };

                    const newFile = {
                        filename: filenameReplace.split('.')[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension
                    };

                    filesArray.push(newFile);

                  
                    try {
                        // Get Upload URL
                        const uploadUrlResponse = await axios.post(
                            `${lambda}/uploadFiles?appname=${appname}&biopsyid=${biopsyid

                            }`,
                            data,
                            { headers: { 'Content-Type': 'application/json' } }
                        );

                        if (uploadUrlResponse.data && uploadUrlResponse.data.result) {
                            const uploadUrl = uploadUrlResponse.data.result;

                            // Upload file to S3
                            const uploadResponse = await axios.put(uploadUrl, file, {
                                headers: {
                                    'Content-Type': file.type,
                                    'Cache-Control': 'no-cache'
                                }
                            });

                            if (uploadResponse.status === 200) {
                                return true; // Successfully uploaded
                            } else {
                                throw new Error('Failed to upload file to S3');
                            }
                        } else {
                            throw new Error('Failed to get upload URL');
                        }
                    } catch (error) {
                        console.error('File upload error:', error);
                        return false;
                    }
                }
            });

            try {
                //const results = await Promise.all(uploadPromises);
                await Promise.all(uploadPromises);

            } catch (error) {
                console.error('Error during file upload:', error);
            }
        }
    };

    // populate pathologist diagnosis fields when case data first loads
    useEffect(() => {
        if (userType === "pathologist" && editUser?.patientid) {
            setDiagnosis(editUser.diagnosis || "");
            setHistopathFindings(editUser.histopathologyfindings || "");
            setPathRemarks(editUser.remarks || "");
        }
    }, [editUser?.patientid]);

    // ── Lab Incharge handlers ───────────────────────────────────────────────

    const fetchPathologists = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(
                `${lambda}/getUsers?appname=${appname}&type=pathologist&token=${token}`
            );
            if (res?.data?.result && Array.isArray(res.data.result)) {
                setPathologistList(res.data.result);
            }
        } catch (err) {
            console.log("fetchPathologists error:", err);
        }
    };

    const handleConfirmPayment = async () => {
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/confirmPayment?appname=${appname}&token=${token}`,
                { caseId: id, confirmedBy: userId, status: "Under Lab Review" }
            );
            setEditUser(prev => ({ ...prev, status: "Under Lab Review" }));
            toast.success("Payment confirmed. Case is now Under Lab Review.");
        } catch (err) {
            console.log("confirmPayment error:", err);
            toast.error("Failed to confirm payment. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleHistologyFileChange = async (event) => {
        const selectedFiles = Array.from(event.target.files);
        selectedFiles.forEach((file, index) => {
            const fileSize = 1048612 * 20;
            if (file.size < fileSize) {
                const adjustedIndex = histologyIndex + index;
                const urlobj = URL.createObjectURL(file);
                const img = new Image();
                img.onload = () => {
                    setHistologyFiles(prev => [...prev, file]);
                    setHistologyUrls(prev => ({
                        ...prev,
                        ["blob" + adjustedIndex]: { url: urlobj, name: file.name },
                    }));
                    setHistologyIndex(adjustedIndex + 1);
                };
                img.src = urlobj;
            } else {
                setFileSizeError(true);
                setFileSizeErrorMsg("File size greater than 20MB");
            }
        });
    };

    const handleHistologyUpload = async () => {
        if (!histologyFiles || histologyFiles.length === 0) {
            toast.error("Please select at least one image to upload.");
            return;
        }
        setIsActionLoading(true);
        try {
            const bucket = window.site?.common?.resourceBucket;
            const filesArray = [];

            await Promise.all(
                histologyFiles.map(async (file) => {
                    const timestamp = Date.now();
                    const fileExtension = file.name.split(".").pop();
                    const ObjectID = require("bson-objectid");
                    const uniqueId = new ObjectID().toString();
                    const fileNameUnique = `${uniqueId}_histology_${timestamp}.${fileExtension}`;
                    const uploadFilePath = `${appname}/${id}/${uniqueId}/${fileNameUnique}`;

                    filesArray.push({
                        filename: file.name.replace(/ /g, "_").split(".")[0],
                        sourcepath: uploadFilePath,
                        fileid: uniqueId,
                        filetype: file.type,
                        filesize: file.size,
                        fileformat: fileExtension,
                    });

                    const signedRes = await axios.post(
                        `${lambda}/uploadFiles?appname=${appname}&biopsyid=${id}`,
                        { source_bucket: bucket, sourcepath: uploadFilePath },
                        { headers: { "Content-Type": "application/json" } }
                    );
                    if (signedRes?.data?.result) {
                        await axios.put(signedRes.data.result, file, {
                            headers: { "Content-Type": file.type, "Cache-Control": "no-cache" },
                        });
                    }
                })
            );

            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/updateBiopsyCase?appname=${appname}&patientid=${id}&token=${token}`,
                { histologyImages: filesArray, updatedBy: userId }
            );

            setEditUser(prev => ({
                ...prev,
                histologyImages: [...(prev.histologyImages || []), ...filesArray],
            }));
            setHistologyFiles([]);
            setHistologyUrls(null);
            setHistologyIndex(0);
            toast.success("Histology images uploaded successfully.");
        } catch (err) {
            console.log("histologyUpload error:", err);
            toast.error("Upload failed. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleAssignPathologist = async () => {
        if (!selectedPathologistId) {
            toast.error("Please select a pathologist.");
            return;
        }
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/assignPathologist?appname=${appname}&token=${token}`,
                { caseId: id, pathologistId: selectedPathologistId, assignedBy: userId, status: "Assigned to Pathologist" }
            );
            setEditUser(prev => ({ ...prev, status: "Assigned to Pathologist", assignedPathologist: selectedPathologistId }));
            toast.success("Case assigned to pathologist.");
        } catch (err) {
            console.log("assignPathologist error:", err);
            toast.error("Assignment failed. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleConfirmAdditionalTestPayment = async () => {
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/confirmAdditionalTestPayment?appname=${appname}&token=${token}`,
                { caseId: id, confirmedBy: userId, status: "Additional Test In Progress" }
            );
            setEditUser(prev => ({ ...prev, status: "Additional Test In Progress" }));
            setAdditionalTestPaymentDone(true);
            toast.success("Additional test payment confirmed.");
        } catch (err) {
            console.log("confirmAdditionalTestPayment error:", err);
            toast.error("Payment confirmation failed. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleReassignPathologist = async () => {
        if (!selectedPathologistId) {
            toast.error("Please select a pathologist to reassign.");
            return;
        }
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/reassignPathologist?appname=${appname}&token=${token}`,
                { caseId: id, pathologistId: selectedPathologistId, reassignedBy: userId, status: "Reassigned to Pathologist" }
            );
            setEditUser(prev => ({ ...prev, status: "Reassigned to Pathologist" }));
            toast.success("Case reassigned to pathologist.");
        } catch (err) {
            console.log("reassignPathologist error:", err);
            toast.error("Reassignment failed. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    // ───────────────────────────────────────────────────────────────────────

    // ── Pathologist handlers ────────────────────────────────────────────────

    const handleSubmitDiagnosis = async () => {
        if (!diagnosis.trim()) {
            toast.error("Please enter a diagnosis.");
            return;
        }
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/submitDiagnosis?appname=${appname}&token=${token}`,
                {
                    caseId: id,
                    diagnosis,
                    histopathFindings,
                    remarks: pathRemarks,
                    submittedBy: userId,
                    status: "Completed",
                }
            );
            setEditUser(prev => ({
                ...prev,
                status: "Completed",
                diagnosis,
                histopathologyfindings: histopathFindings,
                remarks: pathRemarks,
            }));
            toast.success("Diagnosis report submitted successfully.");
        } catch (err) {
            console.log("submitDiagnosis error:", err);
            toast.error("Failed to submit report. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleRequestAdditionalTest = async () => {
        if (!additionalTestDetails.trim()) {
            toast.error("Please enter additional test details.");
            return;
        }
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/requestAdditionalTest?appname=${appname}&token=${token}`,
                {
                    caseId: id,
                    additionalTestDetails,
                    additionalTestCost,
                    requestedBy: userId,
                    status: "Additional Test Requested",
                }
            );
            setEditUser(prev => ({ ...prev, status: "Additional Test Requested" }));
            toast.success("Additional test requested successfully.");
        } catch (err) {
            console.log("requestAdditionalTest error:", err);
            toast.error("Failed to request additional test. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    const handleAddPathAdditionalTest = () => {
        setPathAdditionalTests(prev => [...prev, { name: "", cost: "" }]);
    };

    const handleRemovePathAdditionalTest = (index) => {
        setPathAdditionalTests(prev => prev.filter((_, i) => i !== index));
    };

    const handlePathAdditionalTestChange = (index, field, value) => {
        setPathAdditionalTests(prev =>
            prev.map((t, i) => i === index ? { ...t, [field]: value } : t)
        );
    };

    // ── Teaching Admin handlers ─────────────────────────────────────────────

    const handleConvertToLearningCase = async () => {
        setIsActionLoading(true);
        try {
            const token = localStorage.getItem("token");
            await axios.post(
                `${lambda}/convertToLearningCase?appname=${appname}&token=${token}`,
                { caseId: id, convertedBy: userId, caseType: "Learning Case", status: "Converted to Learning Case" }
            );
            setEditUser(prev => ({ ...prev, caseType: "Learning Case", status: "Converted to Learning Case" }));
            toast.success("Case converted to Learning Case successfully.");
        } catch (err) {
            console.log("convertToLearningCase error:", err);
            toast.error("Conversion failed. Please try again.");
        } finally {
            setIsActionLoading(false);
        }
    };

    // ───────────────────────────────────────────────────────────────────────

    return (
        <>
           
            <div id="layout-wrapper">
                <Header />
              <SideMenu />
              {showSessionPopupup && <SessionPopup />} 
                <SweetAlert show={invalidContent}
                    custom
                    confirmBtnText="ok"
                    confirmBtnBsStyle="primary"
                    title={"User Not Found"}
                    onConfirm={e => onclickInvalid()}
                >
                </SweetAlert>
                {!invalidContent &&

                    <div className="main-content user-management create-user" id="main-content">
                        <div className="page-content" id="page-content">
                            <div className="container-fluid" id="container-fluid">
                                <div className="row mb-4 breadcrumb" id="breadcrumb-row">
                                    <div className="col-lg-12">
                                        <div className="d-flex align-items-center">
                                            <div className="flex-grow-1">
                                                <h4 className="mb-2 card-title" id="breadcrumb-title">
                                                    {id === undefined ? "CASE DETAILS" : "VIEW"}
                                                    {editUser?.status && (
                                                        <span className="ms-3" style={{
                                                            fontSize: "12px",
                                                            fontWeight: "600",
                                                            padding: "3px 10px",
                                                            borderRadius: "4px",
                                                            color: "#fff",
                                                            backgroundColor: {
                                                                "Draft": "#6c757d",
                                                                "Submitted": "#0d6efd",
                                                                "Under Lab Review": "#0dcaf0",
                                                                "Assigned to Pathologist": "#ffc107",
                                                                "Additional Test Requested": "#fd7e14",
                                                                "Additional Test In Progress": "#6f42c1",
                                                                "Reassigned to Pathologist": "#20c997",
                                                                "Completed": "#198754",
                                                                "Converted to Learning Case": "#0a58ca",
                                                            }[editUser.status] || "#6c757d",
                                                        }}>
                                                            {editUser.status}
                                                        </span>
                                                    )}
                                                </h4>
                                                <p className="menu-path" id="breadcrumb-path">
                                                    <span>Biopsy</span> / <b id="breadcrumb-action">VIEW</b>
                                                </p>
                                            </div>
                                            <div>
                                                <a id="back-button" onClick={handleBack} className="stroke-btn-style create-quiz-btn">back
                                                </a>
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div className="row table-data">
                                    <div className="col-12">
                                        <div className="card">
                                            <div className="card-body cpc-management case-info edit-cpc">
                                                <ul className="nav nav-tabs nav-tabs-custom mb-4" role="tablist">
                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "caseinfo" ? "active" : ""}`}
                                                            onClick={() => setActiveTab("caseinfo")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="fas fa-home"></i></span>
                                                            <span className="d-none d-sm-block">CASE INFO</span>
                                                        </button>
                                                    </li>

                                                    {userType !== "doctor" && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "documents" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("documents")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="far fa-user"></i></span>
                                                                <span className="d-none d-sm-block">DOCUMENTS</span>
                                                            </button>
                                                        </li>
                                                    )}

                                                    <li className="nav-item" role="presentation">
                                                        <button
                                                            className={`nav-link ${activeTab === "photos" ? "active" : ""}`}
                                                            onClick={() => setActiveTab("photos")}
                                                            role="tab"
                                                        >
                                                            <span className="d-block d-sm-none"><i className="far fa-envelope"></i></span>
                                                            <span className="d-none d-sm-block">CLINICAL PHOTOS</span>
                                                        </button>
                                                    </li>

                                                    {(userType === "lab technician" || userType === "admin") && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "payment" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("payment")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="fas fa-cog"></i></span>
                                                                <span className="d-none d-sm-block">PAYMENT</span>
                                                            </button>
                                                        </li>
                                                    )}

                                                    {(userType === "lab technician" || userType === "pathologist" || userType === "teaching admin" || userType === "admin") && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "histology" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("histology")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="fas fa-microscope"></i></span>
                                                                <span className="d-none d-sm-block">HISTOLOGY IMAGES</span>
                                                            </button>
                                                        </li>
                                                    )}

                                                    {(userType === "pathologist" || userType === "admin") && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "diagnosis" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("diagnosis")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="fas fa-stethoscope"></i></span>
                                                                <span className="d-none d-sm-block">DIAGNOSIS</span>
                                                            </button>
                                                        </li>
                                                    )}

                                                    {userType === "lab technician" && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "assignpathologist" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("assignpathologist")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="fas fa-user-md"></i></span>
                                                                <span className="d-none d-sm-block">ASSIGN PATHOLOGIST</span>
                                                            </button>
                                                        </li>
                                                    )}

                                                    {(userType === "doctor" || userType === "teaching admin") && editUser?.status === "Completed" && (
                                                        <li className="nav-item" role="presentation">
                                                            <button
                                                                className={`nav-link ${activeTab === "report" ? "active" : ""}`}
                                                                onClick={() => setActiveTab("report")}
                                                                role="tab"
                                                            >
                                                                <span className="d-block d-sm-none"><i className="far fa-file-alt"></i></span>
                                                                <span className="d-none d-sm-block">REPORT</span>
                                                            </button>
                                                        </li>
                                                    )}
                                                </ul>

                                                {activeTab === "caseinfo" && (
                                                    <div className="create-user-block" id="create-user-block">
                                                        {Object.keys(editUser)?.length > 0 ? (
                                                            <>
                                                                <div className="form-block" id="form-block">
                                                                    <div className="row col-lg-12">



                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATH REF NO<span className="required"></span></label>
                                                                                <input id="pathrefno" name="pathrefno" placeholder="Enter Path Ref No" type="number" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.pathrefno} />
                                                                                <span id="pathrefno-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{pathrefnoError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATH REF DATE<span className="required"></span></label>
                                                                                <input id="pathrefdate" name="pathrefdate" placeholder="Enter Path Ref Date" type="date" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.pathrefdate} />
                                                                                <span id="pathrefdate-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{pathrefdateError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">BIOPSY DATE<span className="required"></span></label>
                                                                                <input id="biopsydate" name="biopsydate" placeholder="Enter Date" type="date" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.biopsydate} />
                                                                                <span id="biopsydate-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{biopsydateError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PATIENT NAME<span className="required"></span></label>
                                                                                <input id="patientname" name="patientname" placeholder="Enter Patient Name" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.patientname} />
                                                                                <span id="patientname-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{patientnameError}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">AGE<span className="required"></span></label>
                                                                                <input id="age" name="age" placeholder="Enter Age" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.age} />
                                                                                <span id="age-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{ageError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">GENDER<span className="required"></span></label>
                                                                                <input id="gender" name="gender" placeholder="Enter Gender" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.gender} />
                                                                                <span id="sex-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{sexError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">PHONE<span className="required"></span></label>
                                                                                <input id="phone" name="phone" placeholder="Enter Phone" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.phone} />
                                                                                <span id="phone-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{phoneError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">EMAIL<span className="required"></span></label>
                                                                                <input id="email" name="email"
                                                                                
                                                                                placeholder="Enter Email" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.email} />
                                                                                <span id="email-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{emailError}</span>
                                                                            </div>
                                                                        </div>

                                                                        {/* <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">REFERRING DOCTOR<span className="required"></span></label>
                                                                                <input id="referring-doctor" name="referringDoctor" placeholder="Enter Referring Doctor" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.referringDoctor} />
                                                                                <span id="clinician-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicianError}</span>
                                                                            </div>
                                                                        </div> */}

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">CLINIC REGISTRATION NUMBER<span className="required"></span></label>
                                                                                <input id="clinicregistrationnumber" name="clinicregistrationnumber" placeholder="Enter Clinic Registration Number" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.clinicregistrationnumber} />
                                                                                <span id="clinicregistrationnumber-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicregistrationnumberError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">SPECIMEN TYPE<span className="required"></span></label>
                                                                                <input id="specimentype" name="specimentype" placeholder="Enter Specimen Type" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.specimentype} />
                                                                                <span id="specimentype-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{specimentypeError}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">SITE OF BIOPSY<span className="required"></span></label>
                                                                                <input id="siteofbiopsy" name="siteofbiopsy" placeholder="Enter Site Of Biopsy" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.siteofbiopsy} />
                                                                                <span id="siteofbiopsy-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{siteofbiopsyError}</span>
                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-4 col-md-6 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">Tests</label>
<input id="siteofbiopsy" name="siteofbiopsy" placeholder="Enter Site Of Biopsy" type="text" className="form-control" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.biopsyType?.label} />
                                                                                {/* <Select
                                                                                    isMulti
                                                                                    placeholder={"Select"}
                                                                                    value={selectedTests}
                                                                                    onChange={handleSelectChange}

                                                                                    options={testList && testList.map((eachItem) => { return { value: eachItem.lookupcode, label: eachItem.name } })}
                                                                                    isClearable

                                                                                /> */}

                                                                                {/* <select name="tests" onChange={(e) => handleChange(e)}
                                                                                    value={editUser?.tests} className="form-control form-select">
                                                                                    <option value="">Select</option>
                                                                                    {testList && testList?.length > 0 && testList?.map((task, i) => {
                                                                                        return (
                                                                                            <option key={i} value={task.lookupcode}>{task.name}</option>
                                                                                        )
                                                                                    }
                                                                                    )}
                                                                                </select> */}



                                                                            </div>
                                                                        </div>

                                                                        <div className="col-lg-12 col-md-12 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">CLINICAL HISTORY<span className="required"></span></label>
                                                                                <textarea id="clinicalhistory" name="clinicalhistory" placeholder="Enter Clinical History" type="text" className="form-control edit-cpc-textarea" aria-invalid="false" onChange={(e) => handleChange(e)}disabled value={editUser?.clinicalhistory} rows={5}
                                                                                    cols={5} >
                                                                                </textarea>
                                                                                <span id="clinicalhistory-error" className="errormsg" style={{ fontWeight: 'bold', color: 'red' }}>{clinicalhistoryError}</span>
                                                                            </div>
                                                                        </div>


                                                                        <div className="col-lg-8 col-md-8 col-sm-12">
                                                                            <div className="mb-3 input-field">
                                                                                <input type="checkbox" id="additional-tests" checked disabled />
                                                                                <label className="form_label">Additional Tests<span className="required"></span></label>


                                                                                <Select
                                                                                    isMulti
                                                                                    placeholder={"Select"}
                                                                                    value={selectedBiopsy}
                                                                                    onChange={handleBiopsyChange}

                                                                                    options={biopsyList && biopsyList.map((eachItem) => { return { value: eachItem.lookupcode, label: eachItem.name } })}
                                                                                    isClearable

                                                                                />


                                                                            </div>
                                                                        </div>





                                                                    </div>
                                                                </div>

                                                                {userType === "lab technician" && (editUser?.status === "Additional Test Requested" || editUser?.status === "Additional Test In Progress") && (
                                                                    <div className="col-lg-12 mt-3">
                                                                        <div className="card border mb-0">
                                                                            <div className="card-body p-3">
                                                                                <h6 className="card-title mb-3">Additional Test Details</h6>
                                                                                <div className="mb-3 input-field">
                                                                                    <label className="form_label">REQUESTED TEST(S)</label>
                                                                                    <textarea
                                                                                        className="form-control edit-cpc-textarea"
                                                                                        rows={3}
                                                                                        disabled
                                                                                        value={editUser?.additionalTestDetails || ""}
                                                                                        placeholder="No details recorded"
                                                                                    />
                                                                                </div>
                                                                                <div className="mb-3 input-field">
                                                                                    <label className="form_label">ADDITIONAL TEST COST (₹)</label>
                                                                                    <input
                                                                                        type="text"
                                                                                        className="form-control"
                                                                                        disabled
                                                                                        value={editUser?.additionalTestCost || ""}
                                                                                        placeholder="—"
                                                                                    />
                                                                                </div>
                                                                                {editUser?.status !== "Additional Test In Progress" && !additionalTestPaymentDone ? (
                                                                                    <button
                                                                                        className="create-quiz-btn border-0"
                                                                                        onClick={handleConfirmAdditionalTestPayment}
                                                                                        disabled={isActionLoading}
                                                                                    >
                                                                                        {isActionLoading ? "Processing..." : "Confirm Additional Test Payment"}
                                                                                    </button>
                                                                                ) : (
                                                                                    <div className="mt-2">
                                                                                        <span className="text-success small">
                                                                                            <i className="mdi mdi-check-circle me-1"></i>
                                                                                            Additional test payment confirmed. Upload histology images and reassign pathologist.
                                                                                        </span>
                                                                                        <div className="mt-3">
                                                                                            <label className="form_label">Upload Histology Images</label>
                                                                                            <p className="text-muted file-format mb-2">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                                                            <input
                                                                                                type="file"
                                                                                                className="form-control mb-2"
                                                                                                accept="image/*"
                                                                                                multiple
                                                                                                onChange={handleHistologyFileChange}
                                                                                            />
                                                                                            {histologyUrls && Object.keys(histologyUrls).length > 0 && (
                                                                                                <div className="d-flex flex-wrap gap-3 mt-2 mb-3">
                                                                                                    {Object.entries(histologyUrls).map(([key, item]) => (
                                                                                                        <div className="thumb-box" key={key}>
                                                                                                            <div className="thumb-img">
                                                                                                                <img src={item.url} alt="preview" />
                                                                                                            </div>
                                                                                                            <p className="thumb-name text-truncate small mb-0">{item.name}</p>
                                                                                                        </div>
                                                                                                    ))}
                                                                                                </div>
                                                                                            )}
                                                                                            <button
                                                                                                className="create-quiz-btn border-0 me-2"
                                                                                                onClick={handleHistologyUpload}
                                                                                                disabled={isActionLoading || !histologyFiles?.length}
                                                                                            >
                                                                                                {isActionLoading ? "Uploading..." : "Upload Images"}
                                                                                            </button>
                                                                                        </div>
                                                                                        <div className="mt-3">
                                                                                            <label className="form_label">Reassign Pathologist</label>
                                                                                            <select
                                                                                                className="form-control form-select mb-2"
                                                                                                value={selectedPathologistId}
                                                                                                onChange={(e) => setSelectedPathologistId(e.target.value)}
                                                                                            >
                                                                                                <option value="">-- Select Pathologist --</option>
                                                                                                {pathologistList.map((p) => (
                                                                                                    <option key={p.userid || p._id} value={p.userid || p._id}>
                                                                                                        {p.name || p.username || p.email}
                                                                                                    </option>
                                                                                                ))}
                                                                                            </select>
                                                                                            <button
                                                                                                className="create-quiz-btn border-0"
                                                                                                onClick={handleReassignPathologist}
                                                                                                disabled={isActionLoading || !selectedPathologistId}
                                                                                            >
                                                                                                {isActionLoading ? "Processing..." : "Reassign to Pathologist"}
                                                                                            </button>
                                                                                        </div>
                                                                                    </div>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {/* <div className="row">
                                                                    <div className="col-md-12">
                                                                        <button id="submit-button" className="create-quiz-btn border-0" type="submit" onClick={e => id === undefined ? handleAddUser(e) : handleUpdate(e)}>

                                                                            {id === undefined ? "Create" : "Update"}
                                                                        </button>
                                                                    </div>
                                                                    {msg && <span id="success-msg" className="errormsg" style={{ fontWeight: 'bold', color: 'green' }}>{msg}</span>}
                                                                </div> */}

                                                                {userType === "admin" && editUser?.caseType === "Biopsy" && editUser?.status === "Completed" && (
                                                                    <div className="col-lg-12 mt-4">
                                                                        <div className="card border mb-0">
                                                                            <div className="card-body p-3">
                                                                                <h6 className="card-title mb-2">Convert to Learning Case</h6>
                                                                                <p className="text-muted small mb-3">This completed biopsy case can be converted to a Learning Case for educational use in the platform.</p>
                                                                                <button
                                                                                    className="create-quiz-btn border-0"
                                                                                    onClick={handleConvertToLearningCase}
                                                                                    disabled={isActionLoading}
                                                                                >
                                                                                    {isActionLoading ? "Processing..." : "Convert to Learning Case"}
                                                                                </button>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {userType === "admin" && (editUser?.caseType === "Learning Case" || editUser?.status === "Converted to Learning Case") && (
                                                                    <div className="col-lg-12 mt-4">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <span className="material-icons" style={{ color: "#0a58ca" }}>school</span>
                                                                            <span style={{ fontWeight: "600", color: "#0a58ca" }}>Converted to Learning Case</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </>
                                                        ) : (
                                                            <div className="form-block" id="loading-block">
                                                                <div className="tab-content p-3 text-muted">
                                                                    <div className="tab-pane active show" id="home1" role="tabpanel">
                                                                        <div className="row">
                                                                            <Loader />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        )}
                                                    </div>
                                                )}

                                                {activeTab === "documents" &&
                                                    <div>
                                                        <div className="col-md-12">
                                                            <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                {/* <label className="form_label col-3">DOCUMENTS UPLOAD</label> */}
                                                                <p className="mt-0 mb-0 text-muted col-8 file-format">Note: Supported Formats: WORD, PDF</p>
                                                            </div>

                                                            <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">

                                                                <div className="uploaded_images-grid mb-3 mt-2" /* grid container */>
                                                                  



                                                                    {/* ── Clinical images from editUser.historyfiles ─────────── */}
                                                                    {/* {editUser?.pdfFiles?.length > 0 &&
                                                                                editUser.pdfFiles.map((item, key) => {
                                                                                    const imagePath = `${imageCloudfront}${item?.filepath?.replace(/ /g, '%20')
                                                                                        }?auto=compress,format`;
                                                                                    return (
                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div
                                                                                                className="thumb-img cursor-pointer"
                                                                                                onClick={() => handlePopupImage(imagePath)}
                                                                                            >
                                                                                                <img src={`${imagePath}&width=150`} alt="history" />
                                                                                                
                                                                                                <span
                                                                                                    className="icon-close"
                                                                                                    onClick={(e) => {
                                                                                                        e.stopPropagation();
                                                                                                        handleImageFileDelete(e, item, key, 'file');
                                                                                                    }}
                                                                                                >
                                                                                                    ×
                                                                                                </span>

                                                                                            </div>
                                                                                            <p className="thumb-name text-truncate small mb-0">
                                                                                                {item.filename}
                                                                                            </p>
                                                                                        </div>
                                                                                    );
                                                                                })} */}
                                                                </div>

                                                            </div>
                                                        </div>

                                                       

                                                    </div>
                                                }

                                                {activeTab === "photos" &&
                                                    <div>

                                                        <div className="col-md-12">
                                                            <div className="d-flex col-lg-12 align-items-start justify-content-between">
                                                                {/* <label className="form_label col-3">PHOTOS</label> */}
                                                                <p className="mt-0 mb-0 text-muted col-8 file-format">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                            </div>

                                                            <div className="d-flex justify-content-start col-lg-12 clinical-photo-section gap-3 mt-3">



                                                                {/* Uploaded clinical images */}
                                                                {/* THUMBNAIL GRID */}
                                                                <div className="uploaded_images-grid mb-3 mt-2" /* grid container */>
                                                                   

                                                                    



                                                                    {/* ── Clinical images from editUser.historyfiles ─────────── */}
                                                                    {editUser?.biopsyfiles?.length > 0 &&
                                                                        editUser.biopsyfiles.map((item, key) => {
                                                                            const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')
                                                                                }?auto=compress,format`;
                                                                            return (
                                                                                <div className="thumb-box" key={key}>
                                                                                    <div
                                                                                        className="thumb-img cursor-pointer"
                                                                                        onClick={() => handlePopupImage(imagePath)}
                                                                                    >
                                                                                        <img src={`${imagePath}&width=150`} alt="history" />

                                                                                       

                                                                                    </div>
                                                                                    <p className="thumb-name text-truncate small mb-0">
                                                                                        {item.filename}
                                                                                    </p>
                                                                                </div>
                                                                            );
                                                                        })}
                                                                </div>

                                                            </div>
                                                        </div>

                                                       

                                                    </div>
                                                }
                                                {activeTab === "payment" && (
                                                    <div className="create-user-block">
                                                        <div className="form-block">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-12 mb-3">
                                                                    <h6 className="card-title">Payment Summary</h6>
                                                                    <hr />
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">CASE REFERENCE</label>
                                                                        <input type="text" className="form-control" disabled value={editUser?.pathrefno || ""} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">PATIENT NAME</label>
                                                                        <input type="text" className="form-control" disabled value={editUser?.patientname || ""} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">BIOPSY TYPE</label>
                                                                        <input type="text" className="form-control" disabled value={editUser?.biopsyType?.label || ""} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">DEFAULT TEST</label>
                                                                        <input type="text" className="form-control" disabled value={editUser?.defaultBiopsyTest?.name || "Biopsy Test"} />
                                                                    </div>
                                                                </div>
                                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">TEST COST (₹)</label>
                                                                        <input type="text" className="form-control" disabled value={editUser?.defaultBiopsyTest?.cost || ""} />
                                                                    </div>
                                                                </div>
                                                                {userType === "lab technician" && editUser?.status === "Submitted" && (
                                                                    <div className="col-lg-12 mt-2">
                                                                        <button
                                                                            className="create-quiz-btn border-0"
                                                                            onClick={handleConfirmPayment}
                                                                            disabled={isActionLoading}
                                                                        >
                                                                            {isActionLoading ? "Processing..." : "Confirm Payment"}
                                                                        </button>
                                                                    </div>
                                                                )}
                                                                {userType === "lab technician" && editUser?.status !== "Submitted" && (
                                                                    <div className="col-lg-12 mt-2">
                                                                        <span className="text-muted small">
                                                                            <i className="mdi mdi-check-circle text-success me-1"></i>
                                                                            Payment confirmed — status: <strong>{editUser?.status}</strong>
                                                                        </span>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {activeTab === "histology" && (userType === "lab technician" || userType === "pathologist") && (
                                                    <div className="create-user-block">
                                                        <div className="form-block">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-12 mb-3">
                                                                    <h6 className="card-title">Histology Images</h6>
                                                                    <hr />
                                                                </div>
                                                                {editUser?.histologyImages?.length > 0 ? (
                                                                    <div className="col-lg-12 mb-3">
                                                                        <label className="form_label">Uploaded Images</label>
                                                                        <div className="d-flex flex-wrap gap-3 mt-2">
                                                                            {editUser.histologyImages.map((item, key) => {
                                                                                const imagePath = `${imageCloudfront}${item?.sourcepath?.replace(/ /g, '%20')}?auto=compress,format`;
                                                                                return (
                                                                                    <div className="thumb-box" key={key}>
                                                                                        <div className="thumb-img cursor-pointer" onClick={() => handlePopupImage(imagePath)}>
                                                                                            <img src={`${imagePath}&width=150`} alt="histology" />
                                                                                        </div>
                                                                                        <p className="thumb-name text-truncate small mb-0">{item.filename}</p>
                                                                                    </div>
                                                                                );
                                                                            })}
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    <div className="col-lg-12 mb-3">
                                                                        <p className="text-muted small">No histology images uploaded yet.</p>
                                                                    </div>
                                                                )}
                                                                {userType === "lab technician" && (
                                                                    <>
                                                                        <div className="col-lg-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">Upload New Images</label>
                                                                                <p className="mt-0 mb-2 text-muted file-format">Note: File size: 20 MB | Supported Formats: JPG, PNG</p>
                                                                                <input
                                                                                    type="file"
                                                                                    className="form-control"
                                                                                    accept="image/*"
                                                                                    multiple
                                                                                    onChange={handleHistologyFileChange}
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        {histologyUrls && Object.keys(histologyUrls).length > 0 && (
                                                                            <div className="col-lg-12 mb-3">
                                                                                <label className="form_label">Preview</label>
                                                                                <div className="d-flex flex-wrap gap-3 mt-2">
                                                                                    {Object.entries(histologyUrls).map(([key, item]) => (
                                                                                        <div className="thumb-box" key={key}>
                                                                                            <div className="thumb-img">
                                                                                                <img src={item.url} alt="preview" />
                                                                                            </div>
                                                                                            <p className="thumb-name text-truncate small mb-0">{item.name}</p>
                                                                                        </div>
                                                                                    ))}
                                                                                </div>
                                                                            </div>
                                                                        )}
                                                                        <div className="col-lg-12">
                                                                            <button
                                                                                className="create-quiz-btn border-0"
                                                                                onClick={handleHistologyUpload}
                                                                                disabled={isActionLoading || !histologyFiles?.length}
                                                                            >
                                                                                {isActionLoading ? "Uploading..." : "Upload Histology Images"}
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {activeTab === "assignpathologist" && userType === "lab technician" && (
                                                    <div className="create-user-block">
                                                        <div className="form-block">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-12 mb-3">
                                                                    <h6 className="card-title">Assign Pathologist</h6>
                                                                    <hr />
                                                                </div>
                                                                <div className="col-lg-6 col-md-8 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">SELECT PATHOLOGIST</label>
                                                                        <select
                                                                            className="form-control form-select"
                                                                            value={selectedPathologistId}
                                                                            onChange={(e) => setSelectedPathologistId(e.target.value)}
                                                                        >
                                                                            <option value="">-- Select Pathologist --</option>
                                                                            {pathologistList.map((p) => (
                                                                                <option key={p.userid || p._id} value={p.userid || p._id}>
                                                                                    {p.name || p.username || p.email}
                                                                                </option>
                                                                            ))}
                                                                        </select>
                                                                    </div>
                                                                </div>
                                                                {editUser?.assignedPathologist && (
                                                                    <div className="col-lg-12 mb-2">
                                                                        <span className="text-muted small">
                                                                            Currently assigned: <strong>{editUser.assignedPathologist}</strong>
                                                                        </span>
                                                                    </div>
                                                                )}
                                                                <div className="col-lg-12">
                                                                    <button
                                                                        className="create-quiz-btn border-0"
                                                                        onClick={handleAssignPathologist}
                                                                        disabled={isActionLoading || !selectedPathologistId}
                                                                    >
                                                                        {isActionLoading ? "Processing..." : editUser?.status === "Assigned to Pathologist" ? "Reassign Pathologist" : "Assign Pathologist"}
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {activeTab === "diagnosis" && (userType === "pathologist" || userType === "admin") && (
                                                    <div className="create-user-block">
                                                        <div className="form-block">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-12 mb-3">
                                                                    <h6 className="card-title">Diagnosis Report</h6>
                                                                    <hr />
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">DIAGNOSIS <span className="required">*</span></label>
                                                                        <textarea
                                                                            className="form-control edit-cpc-textarea"
                                                                            rows={4}
                                                                            disabled={editUser?.status === "Completed" || userType === "admin"}
                                                                            value={diagnosis}
                                                                            onChange={(e) => setDiagnosis(e.target.value)}
                                                                            placeholder="Enter diagnosis"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">HISTOPATHOLOGY FINDINGS</label>
                                                                        <textarea
                                                                            className="form-control edit-cpc-textarea"
                                                                            rows={4}
                                                                            disabled={editUser?.status === "Completed" || userType === "admin"}
                                                                            value={histopathFindings}
                                                                            onChange={(e) => setHistopathFindings(e.target.value)}
                                                                            placeholder="Enter histopathology findings"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">REMARKS / NOTES</label>
                                                                        <textarea
                                                                            className="form-control edit-cpc-textarea"
                                                                            rows={3}
                                                                            disabled={editUser?.status === "Completed" || userType === "admin"}
                                                                            value={pathRemarks}
                                                                            onChange={(e) => setPathRemarks(e.target.value)}
                                                                            placeholder="Enter remarks or notes"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 mb-3">
                                                                    <label className="form_label">TESTS / SLIDES</label>
                                                                    <table className="table table-bordered table-sm mb-0">
                                                                        <thead className="table-light">
                                                                            <tr>
                                                                                <th>Test Name</th>
                                                                                <th>Cost (₹)</th>
                                                                            </tr>
                                                                        </thead>
                                                                        <tbody>
                                                                            <tr>
                                                                                <td>
                                                                                    {editUser?.defaultBiopsyTest?.name || "Biopsy Test"}
                                                                                    {/* <span className="ms-2 badge" style={{ background: "#0d6efd", color: "#fff", fontSize: "10px", padding: "2px 6px", borderRadius: "4px" }}>Default</span> */}
                                                                                </td>
                                                                                <td>{editUser?.defaultBiopsyTest?.cost || "—"}</td>
                                                                            </tr>
                                                                            {pathAdditionalTests.map((test, index) => (
                                                                                <tr key={index}>
                                                                                    <td>
                                                                                        <input
                                                                                            type="text"
                                                                                            className="form-control form-control-sm"
                                                                                            value={test.name}
                                                                                            disabled={editUser?.status === "Completed"}
                                                                                            onChange={(e) => handlePathAdditionalTestChange(index, "name", e.target.value)}
                                                                                            placeholder="Test name"
                                                                                        />
                                                                                    </td>
                                                                                    <td>
                                                                                        <input
                                                                                            type="number"
                                                                                            className="form-control form-control-sm"
                                                                                            value={test.cost}
                                                                                            disabled={editUser?.status === "Completed"}
                                                                                            onChange={(e) => handlePathAdditionalTestChange(index, "cost", e.target.value)}
                                                                                            placeholder="0"
                                                                                        />
                                                                                    </td>
                                                                                </tr>
                                                                            ))}
                                                                        </tbody>
                                                                    </table>
                                                                    {editUser?.status !== "Completed" && userType !== "admin" && (
                                                                        <button className="fill_btn mt-2" onClick={handleAddPathAdditionalTest}>
                                                                            <span className="material-icons" style={{ fontSize: "16px", verticalAlign: "middle" }}>add</span> Add Test
                                                                        </button>
                                                                    )}
                                                                </div>

                                                                {editUser?.status !== "Completed" && userType !== "admin" && (
                                                                    <>
                                                                        <div className="col-lg-12 mt-2 mb-2">
                                                                            <hr />
                                                                            <h6 className="card-title">Request Additional Tests (Optional)</h6>
                                                                        </div>
                                                                        <div className="col-lg-12 col-md-12">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">ADDITIONAL TEST DETAILS</label>
                                                                                <textarea
                                                                                    className="form-control edit-cpc-textarea"
                                                                                    rows={3}
                                                                                    value={additionalTestDetails}
                                                                                    onChange={(e) => setAdditionalTestDetails(e.target.value)}
                                                                                    placeholder="Describe the additional tests required"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-4 col-md-6">
                                                                            <div className="mb-3 input-field">
                                                                                <label className="form_label">ADDITIONAL TEST COST (₹)</label>
                                                                                <input
                                                                                    type="number"
                                                                                    className="form-control"
                                                                                    value={additionalTestCost}
                                                                                    onChange={(e) => setAdditionalTestCost(e.target.value)}
                                                                                    placeholder="0"
                                                                                />
                                                                            </div>
                                                                        </div>
                                                                        <div className="col-lg-12 mt-2 d-flex gap-3">
                                                                            <button
                                                                                className="create-quiz-btn border-0"
                                                                                onClick={handleSubmitDiagnosis}
                                                                                disabled={isActionLoading}
                                                                            >
                                                                                {isActionLoading ? "Processing..." : "Submit Report"}
                                                                            </button>
                                                                            <button
                                                                                className="stroke-btn-style create-quiz-btn"
                                                                                onClick={handleRequestAdditionalTest}
                                                                                disabled={isActionLoading}
                                                                            >
                                                                                {isActionLoading ? "Processing..." : "Request Additional Tests"}
                                                                            </button>
                                                                        </div>
                                                                    </>
                                                                )}

                                                                {editUser?.status === "Completed" && (
                                                                    <div className="col-lg-12 mt-3">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <span className="material-icons" style={{ color: "#198754" }}>check_circle</span>
                                                                            <span style={{ fontWeight: "600", color: "#198754" }}>Report submitted — Case Completed</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                                {activeTab === "report" && (userType === "doctor" || userType === "teaching admin") && editUser?.status === "Completed" && (
                                                    <div className="create-user-block">
                                                        <div className="form-block">
                                                            <div className="row col-lg-12">
                                                                <div className="col-lg-12">
                                                                    <div className="mb-1 d-flex align-items-center gap-2">
                                                                        <span className="material-icons" style={{ color: "#198754" }}>check_circle</span>
                                                                        <span style={{ fontWeight: "600", color: "#198754" }}>Case Completed — Final Report</span>
                                                                    </div>
                                                                    <hr />
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">DIAGNOSIS</label>
                                                                        <textarea
                                                                            className="form-control edit-cpc-textarea"
                                                                            rows={4}
                                                                            disabled
                                                                            value={editUser?.diagnosis || ""}
                                                                            placeholder="No diagnosis recorded"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                                    <div className="mb-3 input-field">
                                                                        <label className="form_label">HISTOPATHOLOGY FINDINGS</label>
                                                                        <textarea
                                                                            className="form-control edit-cpc-textarea"
                                                                            rows={4}
                                                                            disabled
                                                                            value={editUser?.histopathologyfindings || ""}
                                                                            placeholder="No findings recorded"
                                                                        />
                                                                    </div>
                                                                </div>

                                                                {editUser?.remarks && (
                                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                                        <div className="mb-3 input-field">
                                                                            <label className="form_label">NOTES / REMARKS</label>
                                                                            <textarea
                                                                                className="form-control edit-cpc-textarea"
                                                                                rows={3}
                                                                                disabled
                                                                                value={editUser?.remarks}
                                                                            />
                                                                        </div>
                                                                    </div>
                                                                )}

                                                                {userType === "teaching admin" && editUser?.caseType !== "Learning Case" && editUser?.status !== "Converted to Learning Case" && (
                                                                    <div className="col-lg-12 mt-3">
                                                                        <hr />
                                                                        <p className="text-muted small mb-2">This completed biopsy case can be converted to a Learning Case for educational use.</p>
                                                                        <button
                                                                            className="create-quiz-btn border-0"
                                                                            onClick={handleConvertToLearningCase}
                                                                            disabled={isActionLoading}
                                                                        >
                                                                            {isActionLoading ? "Processing..." : "Convert to Learning Case"}
                                                                        </button>
                                                                    </div>
                                                                )}

                                                                {(editUser?.caseType === "Learning Case" || editUser?.status === "Converted to Learning Case") && userType === "teaching admin" && (
                                                                    <div className="col-lg-12 mt-3">
                                                                        <div className="d-flex align-items-center gap-2">
                                                                            <span className="material-icons" style={{ color: "#0a58ca" }}>school</span>
                                                                            <span style={{ fontWeight: "600", color: "#0a58ca" }}>Converted to Learning Case</span>
                                                                        </div>
                                                                    </div>
                                                                )}
                                                            </div>
                                                        </div>
                                                    </div>
                                                )}

                                            </div>
                                        </div>
                                    </div>
                                </div>


                            </div>
                        </div>
                    </div>

                }



                {showImagePopup && (
                    <div
                        style={{
                            position: "fixed",
                            top: 0,
                            left: 0,
                            width: "100%",
                            height: "100%",
                            backgroundColor: "rgba(0,0,0,0.8)",
                            zIndex: 1000,
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                        }}
                        onClick={() => setShowImagePopup(false)}
                    >
                        <div style={{ position: "relative", width: "80%", maxWidth: "500px" }}>
                            <img src={popupImage} style={{
                                maxWidth: "500px",
                                width: "100%",
                                height: "auto",
                                display: "block",
                                margin: "0 auto",
                            }} className="modal-img" />
                            {/* <button
                                onClick={() => setShowImagePopup(false)}
                                className="create-quiz-btn border-0"
                                style={{
                                    position: "absolute",
                                    top: 10,
                                    right: 10,
                                    cursor: "pointer",
                                }}
                            >
                                X
                            </button> */}
                        </div>
                    </div>
                )}

            </div>
            <ToastContainer
                id="toastContainer"
                position="bottom-center"
                autoClose={3000}
                hideProgressBar={false}
                newestOnTop={false}
                closeOnClick
                rtl={false}
                pauseOnFocusLoss
                draggable
                pauseOnHover={false}
                theme="light"
            />

            <SweetAlert show={deleteImageSuccess}
                custom
                confirmBtnText="ok"
                confirmBtnBsStyle="primary"
                title={"Deleted Successfully"}
                onConfirm={e => ondeleteImageConfirm()}
            >
            </SweetAlert>

            <SweetAlert show={deleteImage}
                warning
                showCancel
                confirmBtnText="Yes"
                cancelBtnText="Cancel"
                confirmBtnBsStyle="danger"
                cancelBtnBsStyle="default"
                title="Are you sure you want to delete?"
                focusCancelBtn
                onConfirm={e => imageFileDelete(e)}
                onCancel={e => onDelImageCancel(e)}
            >
            </SweetAlert>

            <SweetAlert show={fileSizeError}
                warning
                confirmBtnText="ok"
                confirmBtnBsStyle="danger"
                title={fileSizeErrorMsg}
                onConfirm={e => setFileSizeError(false)}
            >
            </SweetAlert>

        </>
    );
};

export default EditTest;
